import { DropPointType, DropPointTypes, ShippingMethod } from '~/lib/data-contract/salesforce';
import { MapMarker } from '../models';

// API has no type field, so the type is read from the name prefix
const isDropPointType = (marker: MapMarker, type: DropPointType) => marker.name?.startsWith(type);

export const isPostnord = (markers: MapMarker[]) =>
    markers.some(({ carrierCode }) => carrierCode === 'POSTNORD');

export const hasBothDropPointTypes = (markers: MapMarker[]) =>
    markers.some((marker) => isDropPointType(marker, DropPointTypes.packageLocker)) &&
    markers.some((marker) => isDropPointType(marker, DropPointTypes.packageShop));

// SFCC can force packageLocker or packageShop. Any other value, or none, shows both
export const getForcedDropPointType = (carrier?: ShippingMethod) => {
    const type = carrier?.c_dropPointType;
    return type === DropPointTypes.packageLocker || type === DropPointTypes.packageShop
        ? type
        : undefined;
};

// Shows all markers when the type has none for this zip code
export const filterByDropPointType = (markers: MapMarker[], type: DropPointType) => {
    if (type === DropPointTypes.both) return markers;
    const filtered = markers.filter((marker) => isDropPointType(marker, type));
    return filtered.length ? filtered : markers;
};
